import { mapGetters } from "vuex";

/**
 * For features that depends on permissions
 */
export const permissionMixin = {
  computed: {
    ...mapGetters({
      userRole: "getUserRole",
      userType: "getUserType",
      addionalPermissionToAddEditAndDelete:
        "getAddionalPermissionToAddEditAndDelete"
    }),
    /**
     * Check if the user is a protal user or not
     */
    checkIfNotPortalUser() {
      return (
        (this.userRole === 8 ||
          this.userRole === 7 ||
          this.userRole === 11 ||
          this.userRole === 24) &&
        (this.userType === 1 || this.userType === 2 || this.userType === 4)
      );
    },
    /**
     * Weather to show the feature or not
     */
    show() {
      return (
        (this.userRole === 8 ||
          this.userRole === 7 ||
          this.userRole === 11 ||
          this.userRole === 24) &&
        (this.userType === 1 || this.userType === 2 || this.userType === 4) &&
        this.addionalPermissionToAddEditAndDelete
      );
    },
    /**
     * Weather to show drop down option
     */
    showDropDown() {
      return this.checkIfNotPortalUser;
    }
  }
};
